// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 701) return "js/701.js";
	// return url for filenames based on template
	return undefined;
};